import React, { useEffect, useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";



export default function QAReport() {
  const [program, setProgram] = useState("");
  const [centerName, setCenterName] = useState("");
  const [centers, setCenters] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [campaign, setCampaign] = useState("");
  const [campaigns, setCampaigns] = useState([]);
  const [leadSource, setLeadSource] = useState("");
  const [sources, setSources] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);

  // ✅ New: Products state
  const [products, setProducts] = useState([]);


  
// 📌 EXPORT TO EXCEL
const exportToExcel = () => {
  if (rows.length === 0) {
    alert("No data to export!");
    return;
  }

  // Build sheet data
  const sheetData = rows.map((row) => {
    const originalProducts = (row.product || "")
      .split(",")
      .map((p) => p.trim().toLowerCase());

    const approvedProducts = (row.FinalApproved_products || "")
      .split(",")
      .map((p) => p.trim().toLowerCase());

    // Dynamic product YES/NO/NA mapping
    const productStatus = {};
    products.forEach((p) => {
      const name = p.productName.toLowerCase();
      const inOriginal = originalProducts.includes(name);
      const inApproved = approvedProducts.includes(name);

      productStatus[p.productName] = inOriginal
        ? inApproved
          ? "YES"
          : "NO"
        : "NA";
    });

    return {
      CustomerID: row.CustomerID,
      Phone: row.phone,
      AgentName: row.agentName,
      VerifierName: row.verifName,
      CardType: row.cardType,
      VerificationCode: row.verifCode,
      TrackId: row.trackId,
      ...productStatus,
      FinalDisposition: row.finalDisposition,
      Comments: row.qacomments,
      DeclineBase: row.declineBase,
      State: row.state,
      Gender: row.gender,
      SaleSource: row.saleSource,
      LeadSource: row.leadSource,
      Assessor: row.assignedQAUser,
      QaStatus: row.qaStatus,
      QA_VerifiedDate: row.qaverifiedDate
        ? new Date(row.qaverifiedDate).toLocaleString()
        : "",
    };
  });

  // Convert JSON → worksheet → CSV
  const worksheet = XLSX.utils.json_to_sheet(sheetData);
  const csvOutput = XLSX.utils.sheet_to_csv(worksheet);

  // Create Blob for CSV download
  const blob = new Blob([csvOutput], { type: "text/csv;charset=utf-8;" });
  const fileName = `QA_Report_${new Date().toLocaleDateString()}.csv`;

  // Save file
  saveAs(blob, fileName);
};




  // ✅ Fetch Centers
  useEffect(() => {
    const fetchCenters = async () => {
      try {
        const res = await axios.get("https://crm-server-htk6.vercel.app/api/centers");
        const activeCenters = (res.data || []).filter(c => c.status === "Active");
        setCenters(activeCenters);
      } catch (err) {
        console.error("⚠️ Error fetching centers:", err);
      }
    };
    fetchCenters();
  }, []);

  // ✅ Fetch Campaigns
  useEffect(() => {
    const fetchCampaigns = async () => {
      try {
        const res = await axios.get("https://crm-server-htk6.vercel.app/api/campaigns");
        setCampaigns(res.data || []);
      } catch (err) {
        console.error("⚠️ Error fetching campaigns:", err);
      }
    };
    fetchCampaigns();
  }, []);

  // ✅ Fetch Lead Sources
  useEffect(() => {
    const fetchSources = async () => {
      try {
        const res = await axios.get("https://crm-server-htk6.vercel.app/api/leadSources");
        const sortedData = [...res.data].sort((a, b) =>
          a.name.localeCompare(b.name, "en", { sensitivity: "base" })
        );
        setSources(sortedData);
      } catch (err) {
        console.error("⚠️ Error fetching lead sources:", err);
      }
    };
    fetchSources();
  }, []);

  // ✅ Fetch Products (Active Only)
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await axios.get("https://crm-server-htk6.vercel.app/api/products");
        const activeProducts = (res.data || []).filter(p => p.isActive === "Active");
        setProducts(activeProducts);
      } catch (err) {
        console.error("⚠️ Error fetching products:", err);
      }
    };
    fetchProducts();
  }, []);



const handleSearch = async () => {
  try {
    setLoading(true);

    const params = {};
    if (program) params.program = program.trim();
    if (centerName) params.centerName = centerName;
    if (campaign) params.campaign = campaign;
    if (leadSource) params.leadSource = leadSource;
    if (fromDate) params.fromDate = fromDate; // YYYY-MM-DD
    if (toDate) params.toDate = toDate;       // YYYY-MM-DD

    const res = await axios.get(
      "https://crm-server-htk6.vercel.app/api/agents/filterQA",
      { params }
    );

    setRows(res.data || []);
  } catch (err) {
    console.error("⚠️ Error fetching report:", err);
  } finally {
    setLoading(false);
  }
};



  return (
    <div style={{ padding: "20px" }}>
      <h2>QA DVR Report</h2>

      {/* 🔹 Filters Section */}
      <div
        className="filter-bar"
        style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginBottom: "20px" }}
      >
        <div>
          <label>Report Name</label>
          <input type="text" value="QA DVR Report" readOnly />
        </div>

        <div>
          <label>Program</label>
          <input
            type="text"
            value={program}
            onChange={(e) => setProgram(e.target.value)}
            placeholder="Enter Program"
          />
        </div>

        <div>
          <label>Center Name</label>
          <select value={centerName} onChange={(e) => setCenterName(e.target.value)}>
            <option value="">All</option>
            {centers.map((c) => (
              <option key={c._id} value={c.centerName}>
                {c.centerName}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label>From Date</label>
          <input
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
        </div>

        <div>
          <label>To Date</label>
          <input
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>

        <div>
          <label>Campaign</label>
          <select value={campaign} onChange={(e) => setCampaign(e.target.value)}>
            <option value="">All</option>
            {campaigns.map((c) => (
              <option key={c._id} value={c.campaignName}>
                {c.campaignName}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label>Lead Source</label>
          <select value={leadSource} onChange={(e) => setLeadSource(e.target.value)}>
            <option value="">All</option>
            {sources.map((s) => (
              <option key={s._id} value={s.name}>
                {s.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <button className="btn save" onClick={handleSearch}>
        {loading ? "Searching..." : "Search"}
      </button>

    <div style={{ 
  marginTop: "20px", 
  overflowX: "auto", 
  display: "flex", 
  justifyContent: "space-between",
  alignItems: "center"
}}>
  <h3>Report Table</h3>

  <button
    onClick={exportToExcel}
    style={{
      background: "#2b7cff",
      color: "white",
      padding: "8px 14px",
      borderRadius: "5px",
      border: "none",
      cursor: "pointer",
      fontWeight: "bold"
    }}
  >
    Export to Excel
  </button>
</div>

{/* Table Body */}
<div style={{ overflowX: "auto" }}>
  <table className="report-table">

    <thead>
      <tr>
        <th>CustomerID</th>
        <th>Phone No</th>
        <th>Agent Name</th>
        <th>Verifier Name</th>
        <th>Card Type</th>
        <th>Verification Code</th>
        <th>Track Id</th>

        {/* Dynamic product columns */}
        {products.map((p) => (
          <th key={p._id}>{p.productName}</th>
        ))}

        <th>Final Disposition</th>
        <th>Comment_QADVR</th>
        <th>Decline Base</th>
        <th>State Name</th>
        <th>Gender</th>
        <th>Sale Source</th>
        <th>Lead Source</th>
        <th>Assessor</th>
        <th>Consent to Call</th>
        <th>QA-Verified Date</th>
      </tr>
    </thead>

    <tbody>
      {rows.length === 0 ? (
        <tr>
          <td colSpan={18 + products.length} className="no-data">
            No records found
          </td>
        </tr>
      ) : (
        rows.map((row, idx) => {
          
          // 🔹 Original product list (YES/NA baseline)
          const productList = (row.product || "")
            .split(",")
            .map((p) => p.trim().toLowerCase());

          // 🔹 Approved product list (YES/NO logic)
          const approvedList = (row.FinalApproved_products || "")
            .split(",")
            .map((p) => p.trim().toLowerCase())
            .filter(Boolean);

          return (
            <tr key={idx}>
              <td>{row.CustomerID}</td>
              <td>{row.phone}</td>
              <td>{row.agentName}</td>
              <td>{row.verifName}</td>
              <td>{row.cardType}</td>
              <td>{row.verifCode}</td>
              <td>{row.trackId}</td>

              {/* FINAL YES / NO / NA LOGIC */}
              {products.map((p) => {
                const name = p.productName.toLowerCase();

                const inOriginal = productList.includes(name);
                const inApproved = approvedList.includes(name);

                let status = "NA"; // default

                if (inOriginal) {
                  status = inApproved ? "YES" : "NO";
                }

                return <td key={p._id}>{status}</td>;
              })}

              <td>{row.finalDisposition}</td>
              <td>{row.qacomments}</td>
              <td>{row.declineBase}</td>
              <td>{row.state}</td>
              <td>{row.gender}</td>
              <td>{row.saleSource}</td>
              <td>{row.leadSource}</td>
              <td>{row.assignedQAUser}</td>
              <td>{row.qaStatus}</td>
              <td>
                {row.qaverifiedDate
                  ? new Date(row.qaverifiedDate).toLocaleString()
                  : ""}
              </td>
            </tr>
          );
        })
      )}
    </tbody>
  </table>
</div>

    </div>
  );
}
